import React from 'react';
import './ConversationTrainingDialog.css';

interface ConversationTrainingDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  messageCount: number;
  conversationId: string;
  hasFeedbackMessages: boolean;
}

const ConversationTrainingDialog: React.FC<ConversationTrainingDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  messageCount,
  conversationId,
  hasFeedbackMessages
}) => {
  if (!isOpen) return null;

  return (
    <div className="conversation-training-dialog-overlay" onClick={onClose}>
      <div className="conversation-training-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="conversation-training-dialog-header">
          <h3>Submit Whole Conversation for Training</h3>
        </div>
        
        <div className="conversation-training-dialog-content">
          <div className="conversation-training-info">
            <p className="conversation-training-main-text">
              This will submit all {messageCount} message{messageCount !== 1 ? 's' : ''} in this conversation for training.
            </p>
            
            <div className="conversation-training-details">
              <h4>What will be saved:</h4>
              <ul>
                <li>All user questions and assistant responses from this conversation</li>
                <li>All Q&A pairs (question-answer combinations)</li>
                <li>The full conversation context for training</li>
                <li>All {messageCount} message{messageCount !== 1 ? 's' : ''} will be included in the training dataset</li>
              </ul>
            </div>
          </div>

          <div className="conversation-training-impact-notice">
            <div className="impact-notice-icon">ℹ️</div>
            <div className="impact-notice-content">
              <strong>Impact:</strong> This conversation will be used to fine-tune the model. 
              The model will learn from the full context of this conversation, including all user questions and assistant responses. 
              This contributes to improving the model's accuracy and relevance for future responses.
            </div>
          </div>

          <div className="conversation-training-cost-notice">
            <div className="cost-notice-icon">💰</div>
            <div className="cost-notice-content">
              <strong>Cost & Limits:</strong> Fine-tuning has associated costs. Training limits will be applied to manage expenses. 
              This conversation will count towards your training quota.
            </div>
          </div>

          <div className="conversation-training-actions">
            <button
              className="conversation-training-cancel-btn"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="conversation-training-confirm-btn"
              onClick={onConfirm}
            >
              Confirm - Submit Whole Conversation
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversationTrainingDialog;

